import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import {
    faPencil,
    faPlus,
    faX,
    faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useParams } from "react-router";
import middleware from "../../../Api/Middleware";
import ToastError from "../../../Toasts/ToastError";
import { BorderedTextInput } from "../../../HouseStyle/Components/Inputs";
import { BorderedDropDown } from "../../../HouseStyle/Components/DropDowns";
import { ButtonBlue } from "../../../HouseStyle/Components/Buttons";

const UpdatePointsModal = ({
    openUpdatePoints,
    closeUpdatePoints,
    setUpdatedLoyalty,
    totalPoints,
    method
}) => {
    // Usestate variables
    const [showUpdatePoints, setShowUpdatePoints] = useState(false);
    const [points, setPoints] = useState("");
    const [reasons, setReasons] = useState([]);
    const [reason, setReason] = useState(0);
    const [newReason, setNewReason] = useState("");
    const [addNewReason, setAddNewReason] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { internal_id } = useParams();
    // UseEffects
    useEffect(() => {
        if (openUpdatePoints) {
            fetchAll();
            setShowUpdatePoints(true);
        }
        setIsLoading(false);
    }, [openUpdatePoints]);


    useEffect(() => {
        if (reason == "overig" || reason == "overig") {
            setAddNewReason(true);
        } else {
            setAddNewReason(false);
        }
    }, [reason]);


    // Functions
    const fetchAll = async () => {
        if (method == 0) {
            const reasonsResponse = await middleware.get(
                "/loyaltypointreasons?type=0&base=1"
            );
            setReasons(reasonsResponse.data.data);
        } else {
            const reasonsResponse = await middleware.get(
                "/loyaltypointreasons?type=1&base=1"
            );
            setReasons(reasonsResponse.data.data);
        }
    };

    const clearFields = () => {
        setPoints("");
        setAddNewReason(false);
        setReason("");
        setNewReason("");
    }

    const closeUpdatePointsModal = () => {
        setShowUpdatePoints(false);
        clearFields();
        closeUpdatePoints(true);
    };

    const handleInput = (value) => {
        let max_chars = 75;
        if (value.length > max_chars) {
            ToastError(`Reden kan niet meer dan ${max_chars} characters hebben`, 60);
            return;
        }
        setNewReason(value, "newReason");
    }

    const submitNewUpdatePoints = async (event) => {
        setNewReason(newReason.trim());

        if (addNewReason && newReason == "") {
            ToastError("Vul een nieuwe reden in.", 40);
            return;
        }

        if (reasons.some(r => r.reason.toLowerCase() === newReason.trim().toLowerCase())) {
            const downCaseReason = newReason.toLowerCase();
            const upperCaseNewReason = downCaseReason.charAt(0).toUpperCase() + downCaseReason.slice(1);
            ToastError(`${upperCaseNewReason} bestaat al, selecteer het via de dropdown`);
            return;
        }

        if (points < 1 && method == 0) {
            ToastError("Je moet minimaal 1 punt toevoegen.");
            return;
        }

        if (points > 1000000 && method == 0) {
            ToastError("Je mag niet meer dan 1 miljoen punten toevoegen.");
            return;
        }

        if (points < 1 && method == 1) {
            ToastError("Je mag niet meer dan 1 miljoen punten verwijderen.");
            return;
        }

        try {
            if (event)
                event.preventDefault();
            // Convert points to a string with a plus sign
            const pointsWithOperator = method == 0
                ? `+${points}`
                : `-${points}`;

            // If it's a custom reason, create it first
            if (addNewReason && newReason) {
                const reasonResponse = await middleware.post("loyaltypointreasons", {
                    reason: newReason.trim(),
                    type: 0,
                    base: 0
                });

                // Use the newly created reason_id
                if (reasonResponse.data && reasonResponse.data.data) {
                    const newReasonId = reasonResponse.data.data.reason_id;
                    await middleware.post("loyaltymutations", {
                        internal_id: internal_id,
                        amount: pointsWithOperator,
                        reason_id: newReasonId
                    });

                    setUpdatedLoyalty(true);
                    closeUpdatePointsModal();
                }
            } else {
                await middleware.post("loyaltymutations", {
                    internal_id: internal_id,
                    amount: pointsWithOperator,
                    reason_id: reason
                });

                setUpdatedLoyalty(true);
                closeUpdatePointsModal();
            }
        } catch (err) {
            console.error(err);
            ToastError("Er is iets misgegaan bij het toevoegen van punten.");
        }
    }

    const submitNewRemovePoints = async (event) => {

    }

    // const submitNewAddPoints = async (event) => {
    //     setNewReason(newReason.trim());

    //     if (addNewReason && newReason == "") {
    //         ToastError("Vul een nieuwe reden in.", 40);
    //         return;
    //     }

    //     if (reasons.some(r => r.reason.toLowerCase() === newReason.trim().toLowerCase())) {
    //         const downCaseReason = newReason.toLowerCase();
    //         const upperCaseNewReason = downCaseReason.charAt(0).toUpperCase() + downCaseReason.slice(1);
    //         ToastError(`${upperCaseNewReason} bestaat al, selecteer het via de dropdown`);
    //         return;
    //     }

    //     if (points < 1) {
    //         ToastError("Je moet minimaal 1 punt toevoegen.");
    //         return;
    //     }

    //     if (points > 1000000) {
    //         ToastError("Je mag niet meer dan 1 miljoen punten toevoegen.");
    //         return;
    //     }

    //     try {
    //         if (event)
    //             event.preventDefault();
    //         // Convert points to a string with a plus sign
    //         const pointsWithPlus = `+${points}`;

    //         // If it's a custom reason, create it first
    //         if (addNewReason && newReason) {
    //             const reasonResponse = await middleware.post("loyaltypointreasons", {
    //                 reason: newReason.trim(),
    //                 type: 0,
    //                 base: 0
    //             });

    //             // Use the newly created reason_id
    //             if (reasonResponse.data && reasonResponse.data.data) {
    //                 const newReasonId = reasonResponse.data.data.reason_id;
    //                 await middleware.post("loyaltymutations", {
    //                     internal_id: internal_id,
    //                     amount: pointsWithPlus,
    //                     reason_id: newReasonId
    //                 });

    //                 setUpdatedLoyalty(true);
    //                 closeUpdatePointsModal();
    //             }
    //         } else {
    //             await middleware.post("loyaltymutations", {
    //                 internal_id: internal_id,
    //                 amount: pointsWithPlus,
    //                 reason_id: reason
    //             });

    //             setUpdatedLoyalty(true);
    //             closeAddPointsModal();
    //         }
    //     } catch (err) {
    //         console.error(err);
    //         ToastError("Er is iets misgegaan bij het toevoegen van punten.");
    //     }
    // };

    const setPointsValue = (value) => {
        const reg = /^$|^[1-9][0-9]*$/;
        const newValue = value;

        if (newValue > 1000000 && method == 0) {
            ToastError(`Kan niet meer dan 1 millioen punten in één keer toeveogen`, 20);
            setPoints(1000000);
            return;
        }

        if (newValue > totalPoints && method == 1) {
            ToastError(`Totale punten kan niet negatief zijn`, 30);
            setPoints(totalPoints);
            return;
        }

        if (reg.test(newValue)) {
            setPoints(newValue);
        }
    }

    return (
        <Modal
            id="modalBlueprint"
            show={showUpdatePoints}
            onHide={() => closeUpdatePointsModal()}
            className="colormodals"
            size="md"
            centered
        >
            <Modal.Header className="modalTop ps-5 pt-5 justify-content-between">
                {
                    method == 0
                        ? <h3>Punten toevoegen</h3>
                        : <h3>Punten verwijderen</h3>
                }
                <button
                    variant="transparent"
                    className=" btn"
                    onClick={() => closeUpdatePointsModal()}
                >
                    <FontAwesomeIcon icon={faXmark} className="closeModal" />
                </button>
            </Modal.Header>
            <Modal.Body className="modalCenter" style={{ height: "300px" }}>
                <div className="col-12">
                    <div className="d-flex flex-column col-4 mb-3">
                        <div className="d-flex align-items-center">
                            <BorderedTextInput
                                label={method == 0
                                    ? "Punten toevoegen"
                                    : "Punten verwijderen"
                                }
                                inputValue={points}
                                setInputValue={(value) => {
                                    setPointsValue(value);
                                }}
                            />
                        </div>
                    </div>
                    <div className="d-flex flex-column gap-2 col-12">
                        <label className="mb-2 fw-medium">
                            Reden
                            <span className="ms-2 p-2" role="button"></span>
                        </label>
                        <div className="d-flex flex-col">
                            <BorderedDropDown
                                selectedValue={reason}
                                placeholder="Kies een reden"
                                setSelectedValue={(value) => {
                                    setNewReason("");
                                    setReason(value, "reason")
                                }

                                }
                                options={reasons.length > 0 ?
                                    [
                                        ...reasons.map((reason, index) => ({
                                            key: index,
                                            value: reason.reason_id,
                                            title: reason.reason,
                                        })),
                                        {
                                            value: "overig",
                                            title: "Overig",
                                        }
                                    ] :
                                    [{
                                        value: "overig",
                                        title: "Overig",
                                    }]
                                }
                            />
                        </div>
                        {addNewReason && (
                            <BorderedTextInput
                                placeholder="Vul een reden in"
                                inputValue={newReason}
                                setInputValue={handleInput}
                            />
                        )}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="modalBottom">
                <div className="d-flex">
                    <ButtonBlue
                        size="xs"
                        text={"Opslaan"}
                        disabled={
                            reason == 0 || points == "" || isLoading
                        }
                        // onClickFunction={(value) => {
                        //     method == 0 ?
                        //         submitNewAddPoints(value) 
                        //       : submitNewRemovePoints(value)
                        // }}
                        onClickFunction={(value) => {
                            submitNewUpdatePoints(value)
                        }}
                    />
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default UpdatePointsModal;